import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  AllDriversByVehicleIdResponseDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class GetDriversByVehicleIdCommand extends IRequestCommand<
  AllDriversByVehicleIdResponse,
  ErrorDetails,
  IGetDriversByVehicleIdCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierId}/vehicleOwners/vehicle/{vehicleId}/drivers';

  public override setParameters(parameters: IGetDriversByVehicleIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{vehicleId}',
      parameters.vehicleId.toString()
    );
  }
}

export interface IGetDriversByVehicleIdCommandParameters
  extends ICommandParameters {
  carrierId: any;
  vehicleId: any;
}

export interface AllDriversByVehicleIdResponse
  extends AllDriversByVehicleIdResponseDTO,
    ICommandResponse {}
